"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vendorSearchUrl = exports.isVendorStorefrontPage = exports.isVendorStateLandingPage = exports.isVendorSearchResultsPage = exports.isExploreVendorsPage = exports.getSearchedLocation = exports.getSearchLocationForBriefLocation = exports.getBriefLocation = exports.formatLocation = exports.SEARCHED_LOCATION_KEY = exports.DEFAULT_SEARCH_LOCATION = exports.DEFAULT_ALL_MARKETS = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.constructor.js");
require("core-js/modules/es.regexp.dot-all.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.sticky.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.match.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.trim.js");
var _queryString = _interopRequireDefault(require("query-string"));
var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));
var _toTitleCase = require("../transformers/toTitleCase");
var _state = require("../util/state");
var _storage = require("../util/storage");
var _vendorTaxonomyKeys = require("./vendorTaxonomyKeys");
var _nextUtils = require("../util/nextUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/** takes an address object or string and returns a correctly-cased `city, state` string
 *
 * @example formatLocation({ city: 'Germantown', stateProvince: 'NY', ... }); // 'Germantown, NY'
 * @example formatLocation('germantown, ny'); // 'Germantown, NY'
 *
 */
var formatLocation = exports.formatLocation = function formatLocation(location) {
  var _stateProvince;
  if (!location) return '';
  var city;
  var stateProvince;
  if (typeof location === 'string') {
    var matches = location.match(/(.+),\s*(.+)/);
    if (matches) {
      var _matches = _slicedToArray(matches, 3);
      city = _matches[1];
      stateProvince = _matches[2];
    } else if (location.length === 2) {
      stateProvince = location; // The string is probably a state code
    } else {
      city = location; // The string is probably a city
    }
  } else {
    city = location.city;
    stateProvince = location.stateProvince;
  }
  city = (0, _toTitleCase.toTitleCase)(city).trim();
  city = city.replace(/Mc([a-z])/i, function (_, captured) {
    return "Mc".concat((0, _capitalize2.default)(captured));
  });
  city = city.replace(/'([a-z]\S)/i, function (_, captured) {
    return "'".concat((0, _capitalize2.default)(captured));
  });
  city = city.replace(/\s([dl])'/i, function (_, captured) {
    return " ".concat(captured.toLowerCase(), "'");
  });
  stateProvince = (_stateProvince = stateProvince) === null || _stateProvince === void 0 ? void 0 : _stateProvince.toUpperCase().trim();
  return [city, stateProvince].filter(function (e) {
    return e;
  }).join(', ');
};
var getSearchLocationForBriefLocation = exports.getSearchLocationForBriefLocation = function getSearchLocationForBriefLocation(location) {
  return {
    type: 'CITY',
    label: formatLocation({
      city: location.name,
      stateProvince: location.stateCode
    }),
    slug: location.slug,
    stateSlug: (0, _state.getStateSlug)(location.stateCode),
    marketSlug: null,
    usCityId: null,
    storefrontSearchPayload: {
      vendorMarketId: location.vendorMarket.id,
      city: location.name,
      stateProvince: location.stateCode
    },
    geoCoordinates: null
  };
};
var DEFAULT_SEARCH_LOCATION = exports.DEFAULT_SEARCH_LOCATION = {
  name: 'New York',
  stateCode: 'NY',
  slug: 'new-york-ny',
  vendorMarket: {
    id: 3169
  }
};
var DEFAULT_ALL_MARKETS = exports.DEFAULT_ALL_MARKETS = {
  type: 'ALL_MARKETS',
  label: 'All locations',
  slug: 'all-locations'
};
var getBriefLocation = exports.getBriefLocation = function getBriefLocation(weddingLocation) {
  if (weddingLocation) {
    var city = weddingLocation.city,
      stateProvince = weddingLocation.stateProvince,
      citySlug = weddingLocation.citySlug,
      vendorMarket = weddingLocation.vendorMarket;
    if (city && stateProvince && citySlug && vendorMarket !== null && vendorMarket !== void 0 && vendorMarket.id) {
      return {
        name: city,
        stateCode: stateProvince,
        slug: citySlug,
        vendorMarket: {
          id: vendorMarket.id
        }
      };
    }
    return DEFAULT_SEARCH_LOCATION;
  }
  return DEFAULT_SEARCH_LOCATION;
};
var SEARCHED_LOCATION_KEY = exports.SEARCHED_LOCATION_KEY = 'zola_marketplace_selected_location';

/**
 * Get the searched location from cookies
 */
var getSearchedLocation = exports.getSearchedLocation = function getSearchedLocation() {
  var location = typeof window !== 'undefined' ? (0, _storage.getCookie)(SEARCHED_LOCATION_KEY) : '';
  if (location) {
    return JSON.parse(location);
  }
  // default to all
  return DEFAULT_ALL_MARKETS;
};

/**
 * Generates a URL to search for vendors
 *
 * @param {*} vendorTaxonomyKey - Which vendor is searched
 * @param {*} selectedLocationSlug - Where is the search, this is more important for SEO so it comes first in the generated url
 * @param {*} otherSlugs - Any additional slugs, separated by -- to include. Use for filters.
 * @param {*} queryString - Query string to include in the URL.  Used for filters like price or availability.
 *
 * @returns URL to a vendor search page
 */
var vendorSearchUrl = exports.vendorSearchUrl = function vendorSearchUrl() {
  var vendorTaxonomyKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var selectedLocationSlug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var otherSlugs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var query = arguments.length > 3 ? arguments[3] : undefined;
  var parts = [selectedLocationSlug, vendorTaxonomyKey].concat(_toConsumableArray(otherSlugs));
  // The all-locations is historical and can probably be removed
  var slugs = parts.filter(function (part) {
    return !!part && part !== 'all-locations';
  }).join('--');
  var paths = ['wedding-vendors', 'search', slugs].filter(function (part) {
    return !!part;
  });
  var url = "/".concat(paths.join('/'));
  return _queryString.default.stringifyUrl({
    url: url,
    query: query
  });
};
var TAXONOMY_KEYS_REGEX = _vendorTaxonomyKeys.SEARCHABLE_VENDOR_TAXONOMY_KEYS.join('|');

/**
 * Returns true if the path is a vendor storefront page.  If path is not provided
 * this will check the window location.  This can be called on the server by
 * passing in the page URL;
 *
 * @returns
 */
var isVendorStorefrontPage = exports.isVendorStorefrontPage = function isVendorStorefrontPage(path) {
  // Path wasn't provided, if we're on the server, we can't check
  if (!path && !(0, _nextUtils.isClient)()) return false;
  var pathRegExp = new RegExp("^/wedding-vendors/(".concat(TAXONOMY_KEYS_REGEX, ")/."));
  return pathRegExp.test(path || window.location.pathname);
};

/**
 * Determines whether the current path is an explore or category landing page
 *
 * @example
 * `/wedding-vendors`
 * `/wedding-vendors/wedding-photographers`
 */
var isExploreVendorsPage = exports.isExploreVendorsPage = function isExploreVendorsPage(path) {
  // Path wasn't provided, if we're on the server, we can't check
  if (!path && !(0, _nextUtils.isClient)()) return false;
  var pathRegExp = new RegExp("^/wedding-vendors(/(".concat(TAXONOMY_KEYS_REGEX, ")?)?$"));
  return pathRegExp.test(path || window.location.pathname);
};

/**
 * Determines whether the current path is a search results page
 *
 * @example
 * `/wedding-vendors/search/new-york-ny--wedding-photographers`
 * `/wedding-vendors/near-me/wedding-photographers`
 */
var isVendorSearchResultsPage = exports.isVendorSearchResultsPage = function isVendorSearchResultsPage(path) {
  // Path wasn't provided, if we're on the server, we can't check
  if (!path && !(0, _nextUtils.isClient)()) return false;
  var pathRegExp = new RegExp("^/wedding-vendors(/(search|near-me)/.*)?$");
  return pathRegExp.test(path || window.location.pathname);
};

/**
 * Determines whether the current path is a state landing page
 *
 * @example
 * `/wedding-vendors/states/california/venues`
 * `/wedding-vendors/states/california/vendors`
 */
var isVendorStateLandingPage = exports.isVendorStateLandingPage = function isVendorStateLandingPage(path) {
  // Path wasn't provided, if we're on the server, we can't check
  if (!path && !(0, _nextUtils.isClient)()) return false;
  var pathRegExp = new RegExp("^/wedding-vendors/states/.+$");
  return pathRegExp.test(path || window.location.pathname);
};